import { ContractTypeEnum } from './type';

/**
 * 获取协议 iframe URL（处理 PDF 和普通协议）
 * @param url 协议地址
 * @param type 协议类型
 * @returns 处理后的协议 URL
 */
export const getContractIframeUrl = (url: string, type?: ContractTypeEnum): string => {
  if (!url) {
    return '';
  }
  // 如果是 PDF 类型，使用 PDF 预览器
  if (type === ContractTypeEnum.PDF || url.toLowerCase().endsWith('.pdf')) {
    const contractsUrl = process.env.VUE_APP_CONTRACTS_URL || '';
    return `${contractsUrl}?pdf_url=${url}`;
  }
  return url;
};


/** 格式化协议名称（截断超过9字并添加省略号） */
export const formatContractName = (name: string): string => {
  // 1. 去除首尾的<、》、《、>符号
  const processedName = name
    .trim()
    .replace(/^[\u003c|《]?(.+?)[\u003e|》]?$/, '$1');

  // 2. 截断处理（超过9字则显示前9字+...）
  const truncatedName = processedName.length > 9
    ? `${processedName.slice(0, 9)}...`
    : processedName;

  // 3. 添加书名号
  return `《${truncatedName}》`;
};
